import React from 'react'
import Slider from './Components/HeroSection/Slider'
import Todatoffersbaner from './Components/TodayOffers/Todatoffersbaner'
import Todayoffers from './Components/TodayOffers/TodayOffers'
import ImagesCoupons from './Components/Coupons/ImagesCoupons'
import SeasonalOffers from './Components/SeasonalOffers/SeasonalOffers'
import Mail from './Components/Mail'
import PickyourProducts from './Components/PickyourProducts'
import Header from './Components/Header'
import Footer from './Components/Footer/Footer'

const HomeRefaral = () => {
  const currentPathname = window.location.pathname;
  // console.log('Current Pathname:', currentPathname);

  const isSingleSegment = /^\/[^/]+$/.test(currentPathname); // e.g., "/abc123"

  if (isSingleSegment) {
    // console.log('Matched single dynamic path:', currentPathname);
  }
  return (
    <div>
      <Header hideLayout={isSingleSegment}/>
      <update-meta-data 
        stitle="Grab the Best Free Coupons and Deals Online – Save Big Today! – bakpoket " 
        sdescription="Discover the latest free coupons, exclusive promo codes, and unbeatable online deals. Start saving instantly on your favorite brands and stores! – bakpoket" 
        scanonical="https://bakpoket.com/" 
        class="ng-scope">
      </update-meta-data>

        <Slider/>
        <Todatoffersbaner/>
        <Todayoffers/>
        <ImagesCoupons/>
        <PickyourProducts/>
        <SeasonalOffers />
        <Mail/>
        <Footer/>
    </div>
  )
}

export default HomeRefaral
